import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f34a5248"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-f" }
const _hoisted_2 = {
  class: "flex-div search-btns",
  style: {"justify-content":"end","background":"#fff","padding-right":"10px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Submit")
const _hoisted_5 = { class: "bg-fff m-t-8 searchMain" }
const _hoisted_6 = { class: "d-f" }
const _hoisted_7 = { class: "d-f flex-w-auto m-l-16 line-h-30 flex-d-c" }
const _hoisted_8 = { class: "m-b-10 d-f" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label-text-12",
  style: {"width":"80px"}
}, "Batch Name:", -1))
const _hoisted_10 = { class: "d-f" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label-text-12",
  style: {"width":"80px"}
}, "Approve Line:", -1))
const _hoisted_12 = { class: "d-f flex-w-auto m-l-16 line-h-30 flex-d-c" }
const _hoisted_13 = { class: "m-b-15" }
const _hoisted_14 = { class: "label-text-121" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("BU: ")
const _hoisted_16 = { class: "text-bold" }
const _hoisted_17 = { class: "label-text-121" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Submit Date: ")
const _hoisted_19 = { class: "text-bold" }
const _hoisted_20 = { class: "d-f flex-w-auto m-l-16 line-h-30 flex-d-c" }
const _hoisted_21 = { class: "m-b-15" }
const _hoisted_22 = { class: "label-text-121" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("NO. of Program: ")
const _hoisted_24 = { class: "text-bold" }
const _hoisted_25 = { class: "label-text-121" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Batch Approval Status: ")
const _hoisted_27 = { class: "text-bold" }
const _hoisted_28 = { class: "d-f flex-w-auto m-l-16 line-h-30 flex-d-c" }
const _hoisted_29 = { class: "label-text-121" }
const _hoisted_30 = { class: "text-bold" }
const _hoisted_31 = { class: "d-f flex-w-auto m-l-16 line-h-30 flex-d-c" }
const _hoisted_32 = { class: "m-b-15" }
const _hoisted_33 = { class: "label-text-121" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Batch Total Budget: ")
const _hoisted_35 = { class: "text-bold" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" E-Mail Reminder ")
const _hoisted_37 = { class: "table-main bg-fff m-t-8 flex-w-auto" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-f align-c" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title sign-line-b" }, "Program List")
], -1))
const _hoisted_39 = { class: "footer-btns m-t-16" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Remove")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_ApproveSteps = _resolveComponent("ApproveSteps")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_AddProgram = _resolveComponent("AddProgram")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_main_wrapper = _resolveComponent("main-wrapper")!

  return (_openBlock(), _createBlock(_component_main_wrapper, { className: "p-l-r-10" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Breadcrumb, { dataSource: [{ name: 'Batch Package', path: '' }] }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            class: "m-l-16",
            disabled: _ctx.disableBatchStatus.includes(_ctx.status),
            onClick: _ctx.handlerSaveClick
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_a_button, {
            class: "m-l-16",
            disabled: _ctx.disableBatchStatus.includes(_ctx.status),
            type: "primary",
            onClick: _ctx.handlerSubmitClick
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_a_input, {
                style: {"width":"200px","margin-left":"3px"},
                value: _ctx.validateData.batchName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.validateData.batchName) = $event)),
                placeholder: "input batch name"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_a_select, {
                value: _ctx.validateData.approveLine,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.validateData.approveLine) = $event)),
                ref: "select",
                style: {"width":"200px","margin-left":"3px"},
                "show-search": "",
                onBlur: _ctx.handleChangeLine
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apprpveList, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item,
                      key: item
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onBlur"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.validateData.bu), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.createdAt), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.programDto.length), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.status), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listBudget, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass({ 'm-b-15': index == 0 }),
                key: index
              }, [
                _createElementVNode("span", _hoisted_29, [
                  _createTextVNode(_toDisplayString(item.make) + ": ", 1),
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.toThousands(item.budget)), 1)
                ])
              ], 2))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("span", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.toThousands(_ctx.totalBudget)), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_ApproveSteps, {
        data: _ctx.approveProgressData.nodeList
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            class: "email-alert-btn",
            disabled: _ctx.status !== 'Approving',
            onClick: _ctx.handleShowEmailAlertDialog
          }, {
            default: _withCtx(() => [
              _hoisted_36
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      }, 8, ["data"]),
      _createElementVNode("div", _hoisted_37, [
        _hoisted_38,
        _createVNode(_component_a_table, {
          class: "tab-container m-t-20 default-self-table-text",
          dataSource: _ctx.programDto,
          columns: _ctx.columns,
          pagination: false,
          "row-selection": _ctx.rowSelection,
          rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null),
          scroll: { x: 1000 },
          rowKey: (item, index) => item.programId
        }, {
          submitDate: _withCtx(({ text }) => [
            _createTextVNode(_toDisplayString(text ? _ctx.moment(text).format('YYYY-MM-DD') : text), 1)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "row-selection", "rowClassName", "rowKey"]),
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_a_button, {
            class: "m-l-16 ant-btn",
            disabled: _ctx.disableBatchStatus.includes(_ctx.status),
            onClick: _ctx.handlerAddClick
          }, {
            default: _withCtx(() => [
              _hoisted_40
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_a_button, {
            class: "m-l-16 ant-btn",
            disabled: _ctx.disableBatchStatus.includes(_ctx.status),
            onClick: _ctx.handlerRemoveClick
          }, {
            default: _withCtx(() => [
              _hoisted_41
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      _createVNode(_component_AddProgram, {
        visible: _ctx.visibleAddProgramModal,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visibleAddProgramModal) = $event)),
        dataSource: _ctx.programList,
        onConfirm: _ctx.handlerConfirmClick
      }, null, 8, ["visible", "dataSource", "onConfirm"]),
      _createVNode(_component_a_modal, {
        visible: _ctx.emailAlertDialogVisible,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.emailAlertDialogVisible) = $event)),
        okText: "Confirm",
        title: "E-Mail Reminder",
        onOk: _ctx.handleSend
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, "Are you sure to send E-Mail to Approver " + _toDisplayString(_ctx.approvers) + "?", 1)
        ]),
        _: 1
      }, 8, ["visible", "onOk"])
    ]),
    _: 1
  }))
}